/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceEventAttendanceService {
  /** @summary Get Current */
  getCurrentAttendancesCurrentGet: {
    /** @summary Get Current */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetCurrentAttendancesCurrentGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetCurrentAttendancesCurrentGetSchema,
        options: {
          parameters: GetCurrentAttendancesCurrentGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>>
    ): Promise<RequestFnResponse<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>>;
    /** @summary Get Current */
    getQueryKey(
      parameters: DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void
    ): ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useQuery()
     * ```
     */
    useQuery<TData = GetCurrentAttendancesCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCurrentAttendancesCurrentGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useQuery()
     * ```
     */
    useQuery<TData = GetCurrentAttendancesCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCurrentAttendancesCurrentGetError>>;
    /** @summary Get Current */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetCurrentAttendancesCurrentGetSchema,
      GetCurrentAttendancesCurrentGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCurrentAttendancesCurrentGetParameters,
      TQueryFnData = GetCurrentAttendancesCurrentGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCurrentAttendancesCurrentGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCurrentAttendancesCurrentGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCurrentAttendancesCurrentGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCurrentAttendancesCurrentGetParameters,
      TQueryFnData = GetCurrentAttendancesCurrentGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCurrentAttendancesCurrentGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCurrentAttendancesCurrentGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCurrentAttendancesCurrentGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCurrentAttendancesCurrentGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCurrentAttendancesCurrentGetTotal = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCurrentAttendancesCurrentGetResults = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentAttendancesCurrentGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCurrentAttendancesCurrentGetCombinedResults = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentAttendancesCurrentGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCurrentAttendancesCurrentGetSchema,
          GetCurrentAttendancesCurrentGetParameters,
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetCurrentAttendancesCurrentGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError,
          TData,
          ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCurrentAttendancesCurrentGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCurrentAttendancesCurrentGetParameters,
      TData = GetCurrentAttendancesCurrentGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError,
          OperationInfiniteData<TData, GetCurrentAttendancesCurrentGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCurrentAttendancesCurrentGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCurrentAttendancesCurrentGetParameters>,
      OperationError<GetCurrentAttendancesCurrentGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Current
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCurrentAttendancesCurrentGetData = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentAttendancesCurrentGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCurrentAttendancesCurrentGetCombinedData = qraft.serviceEventAttendanceService.getCurrentAttendancesCurrentGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getCurrentAttendancesCurrentGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCurrentAttendancesCurrentGetSchema,
          GetCurrentAttendancesCurrentGetParameters,
          GetCurrentAttendancesCurrentGetData,
          GetCurrentAttendancesCurrentGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Current */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<GetCurrentAttendancesCurrentGetData>;
    /** @summary Get Current */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<void>;
    /** @summary Get Current */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<GetCurrentAttendancesCurrentGetData>;
    /** @summary Get Current */
    fetchInfiniteQuery<TPageParam extends GetCurrentAttendancesCurrentGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>>;
    /** @summary Get Current */
    prefetchInfiniteQuery<TPageParam extends GetCurrentAttendancesCurrentGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<void>;
    /** @summary Get Current */
    ensureInfiniteQueryData<TPageParam extends GetCurrentAttendancesCurrentGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        GetCurrentAttendancesCurrentGetParameters,
        DeepReadonly<TPageParam>,
        GetCurrentAttendancesCurrentGetError
      > | void
    ): Promise<OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>>;
    /** @summary Get Current */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void)
    ): GetCurrentAttendancesCurrentGetData | undefined;
    /** @summary Get Current */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void)
    ):
      | OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>
      | undefined;
    /** @summary Get Current */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCurrentAttendancesCurrentGetSchema,
              GetCurrentAttendancesCurrentGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCurrentAttendancesCurrentGetSchema,
              GetCurrentAttendancesCurrentGetParameters
            >,
            data: GetCurrentAttendancesCurrentGetData | undefined,
          ]
        >;
    /** @summary Get Current */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | void)
    ): QueryState<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetError> | undefined;
    /** @summary Get Current */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCurrentAttendancesCurrentGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>,
          GetCurrentAttendancesCurrentGetError
        >
      | undefined;
    /** @summary Get Current */
    setQueryData(
      parameters:
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | undefined)
        | ServiceOperationQueryKey<GetCurrentAttendancesCurrentGetSchema, GetCurrentAttendancesCurrentGetParameters>,
      updater: Updater<
        NoInfer<GetCurrentAttendancesCurrentGetData> | undefined,
        NoInfer<DeepReadonly<GetCurrentAttendancesCurrentGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCurrentAttendancesCurrentGetData | undefined;
    /** @summary Get Current */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetCurrentAttendancesCurrentGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetCurrentAttendancesCurrentGetData, GetCurrentAttendancesCurrentGetParameters>
      | undefined;
    /** @summary Get Current */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >,
      updater: Updater<
        NoInfer<GetCurrentAttendancesCurrentGetData> | undefined,
        NoInfer<GetCurrentAttendancesCurrentGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCurrentAttendancesCurrentGetData | undefined>;
    /** @summary Get Current */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCurrentAttendancesCurrentGetSchema,
        GetCurrentAttendancesCurrentGetData,
        TInfinite,
        GetCurrentAttendancesCurrentGetParameters,
        GetCurrentAttendancesCurrentGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Current */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Current */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Current */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
    ): void;
    /** @summary Get Current */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Current */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
        | QueryFiltersByQueryKey<
            GetCurrentAttendancesCurrentGetSchema,
            GetCurrentAttendancesCurrentGetData,
            TInfinite,
            GetCurrentAttendancesCurrentGetParameters,
            GetCurrentAttendancesCurrentGetError
          >
    ): number;
    schema: GetCurrentAttendancesCurrentGetSchema;
    types: {
      parameters: GetCurrentAttendancesCurrentGetParameters;
      data: GetCurrentAttendancesCurrentGetData;
      error: GetCurrentAttendancesCurrentGetError;
    };
  };
  /** @summary Check In */
  checkInServiceEventsServiceEventIdAttendancesCheckInPost: {
    /** @summary Check In */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
        options: ServiceOperationMutationFnOptions<
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostError
      >
    >;
    /** @summary Check In */
    getMutationKey(
      parameters: DeepReadonly<CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters> | void
    ): ServiceOperationMutationKey<
      CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
      CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Check In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody, TContext = unknown>(
      parameters: DeepReadonly<CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
        TVariables,
        OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
        TContext
      >
    ): UseMutationResult<
      CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
      OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Check In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
        TVariables,
        OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
        TContext
      >
    ): UseMutationResult<
      CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
      OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Check In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const checkInServiceEventsServiceEventIdAttendancesCheckInPostTotal = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const checkInServiceEventsServiceEventIdAttendancesCheckInPostTotal = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Check In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const checkInServiceEventsServiceEventIdAttendancesCheckInPostPendingMutationVariables = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const checkInServiceEventsServiceEventIdAttendancesCheckInPostMutationData = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
        OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
        MutationVariables<
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
          OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
          MutationVariables<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Check In */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
            OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Check In
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventAttendanceService.checkInServiceEventsServiceEventIdAttendancesCheckInPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
              OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
              OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
              TContext
            >
      ):
        | Mutation<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostError,
            MutationVariables<
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
              OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
              CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters,
              OperationError<CheckInServiceEventsServiceEventIdAttendancesCheckInPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostData,
          CheckInServiceEventsServiceEventIdAttendancesCheckInPostError,
          MutationVariables<
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody,
            CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema;
    types: {
      parameters: CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters;
      data: CheckInServiceEventsServiceEventIdAttendancesCheckInPostData;
      error: CheckInServiceEventsServiceEventIdAttendancesCheckInPostError;
      body: CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody;
    };
  };
  /** @summary Check Out */
  checkOutServiceEventsServiceEventIdAttendancesCheckOutPut: {
    /** @summary Check Out */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
        options: ServiceOperationMutationFnOptions<
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError
      >
    >;
    /** @summary Check Out */
    getMutationKey(
      parameters: DeepReadonly<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters> | void
    ): ServiceOperationMutationKey<
      CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
      CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Check Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody, TContext = unknown>(
      parameters: DeepReadonly<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
        TVariables,
        OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
        TContext
      >
    ): UseMutationResult<
      CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
      OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Check Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
        TVariables,
        OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
        TContext
      >
    ): UseMutationResult<
      CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
      OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Check Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const checkOutServiceEventsServiceEventIdAttendancesCheckOutPutTotal = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const checkOutServiceEventsServiceEventIdAttendancesCheckOutPutTotal = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Check Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const checkOutServiceEventsServiceEventIdAttendancesCheckOutPutPendingMutationVariables = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const checkOutServiceEventsServiceEventIdAttendancesCheckOutPutMutationData = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
        OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
        MutationVariables<
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
          OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
          MutationVariables<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Check Out */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
            OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Check Out
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventAttendanceService.checkOutServiceEventsServiceEventIdAttendancesCheckOutPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
              OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
              OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
              TContext
            >
      ):
        | Mutation<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError,
            MutationVariables<
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
              OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
              CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters,
              OperationError<CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError>,
              TContext
            >
      ): Array<
        Mutation<
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData,
          CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError,
          MutationVariables<
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody,
            CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters
          >,
          TContext
        >
      >;
    };
    schema: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema;
    types: {
      parameters: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters;
      data: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData;
      error: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError;
      body: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody;
    };
  };
}
/** @summary Get Current */
export const getCurrentAttendancesCurrentGet = {
  schema: {
    method: 'get',
    url: '/attendances/current',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCurrentAttendancesCurrentGetSchema;
  [QraftServiceOperationsToken]: ServiceEventAttendanceService['getCurrentAttendancesCurrentGet'];
};
/** @summary Check In */
export const checkInServiceEventsServiceEventIdAttendancesCheckInPost = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/attendances/check_in',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema;
  [QraftServiceOperationsToken]: ServiceEventAttendanceService['checkInServiceEventsServiceEventIdAttendancesCheckInPost'];
};
/** @summary Check Out */
export const checkOutServiceEventsServiceEventIdAttendancesCheckOutPut = {
  schema: {
    method: 'put',
    url: '/service_events/{service_event_id}/attendances/check_out',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema;
  [QraftServiceOperationsToken]: ServiceEventAttendanceService['checkOutServiceEventsServiceEventIdAttendancesCheckOutPut'];
};
export const serviceEventAttendanceService = {
  getCurrentAttendancesCurrentGet,
  checkInServiceEventsServiceEventIdAttendancesCheckInPost,
  checkOutServiceEventsServiceEventIdAttendancesCheckOutPut,
} as const;
type GetCurrentAttendancesCurrentGetSchema = {
  method: 'get';
  url: '/attendances/current';
  security: ['HTTPBearer'];
};
type GetCurrentAttendancesCurrentGetParameters = undefined;
type GetCurrentAttendancesCurrentGetData =
  paths['/attendances/current']['get']['responses']['200']['content']['application/json'];
type GetCurrentAttendancesCurrentGetError = unknown;
type CheckInServiceEventsServiceEventIdAttendancesCheckInPostSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/attendances/check_in';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CheckInServiceEventsServiceEventIdAttendancesCheckInPostParameters =
  paths['/service_events/{service_event_id}/attendances/check_in']['post']['parameters'];
type CheckInServiceEventsServiceEventIdAttendancesCheckInPostData =
  paths['/service_events/{service_event_id}/attendances/check_in']['post']['responses']['200']['content']['application/json'];
type CheckInServiceEventsServiceEventIdAttendancesCheckInPostError =
  paths['/service_events/{service_event_id}/attendances/check_in']['post']['responses']['422']['content']['application/json'];
type CheckInServiceEventsServiceEventIdAttendancesCheckInPostBody =
  paths['/service_events/{service_event_id}/attendances/check_in']['post']['requestBody']['content']['application/json'];
type CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutSchema = {
  method: 'put';
  url: '/service_events/{service_event_id}/attendances/check_out';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutParameters =
  paths['/service_events/{service_event_id}/attendances/check_out']['put']['parameters'];
type CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutData =
  paths['/service_events/{service_event_id}/attendances/check_out']['put']['responses']['200']['content']['application/json'];
type CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutError =
  paths['/service_events/{service_event_id}/attendances/check_out']['put']['responses']['422']['content']['application/json'];
type CheckOutServiceEventsServiceEventIdAttendancesCheckOutPutBody =
  paths['/service_events/{service_event_id}/attendances/check_out']['put']['requestBody']['content']['application/json'];
